import React from "react";
import { Col } from "reactstrap";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PublicLayout from "components/PublicLayout";

const Error = () => {
  const { t } = useTranslation();

  return (
    <PublicLayout>
      <Col lg="6" md="12" className="mt-4 mx-auto">
        <div className="card mt-2 public-card">
          <div className="card-body status-panel">
            <p className="text-muted text-small mb-1">404</p>
            <h2 className="mb-2">{t("notFoundTitle")}</h2>
            <p className="text-muted mb-4">{t("notFoundBody")}</p>
            <NavLink to="/" className="btn btn-primary btn-lg">
              {t("goToPayment")}
            </NavLink>
          </div>
        </div>
      </Col>
    </PublicLayout>
  );
};

export default Error;
